<div>
    <h2 style="margin-bottom: 5px;">{{'newOrder.trialLens.tabs.newParameter.title' | translate}}</h2>
</div>

<div>
    <form [formGroup]="form">

        <div class="d-flex">

            <div class="d-flex new-parameter-autocomplete">
                <label class="input-wrapper-chevron-down">{{"newOrder.trialLens.material" | translate}}<span class="span-label-required"></span>
                  <input [ngClass]="{required:true, error: form.get('material').errors && (form.get('material').touched || (form.get('material').dirty))}" [id]="'materialAutocomplete' + side"
                  type="text" class="form-control parameter-input" [placeholder]="'common.hints.pleaseSelect' | translate" [matAutocomplete]="materialAutocomplete" formControlName="material">
                </label>
                <mat-autocomplete #materialAutocomplete="matAutocomplete">
                  <mat-option *ngFor="let material of filteredMaterial | async" [value]="material" (click)="selectMaterial()">
                    {{material}}
                  </mat-option>
                </mat-autocomplete>
            </div>

            <div class="d-flex new-parameter">
                <label [matTooltip]="'common.hints.RadiusBasecurve' | translate" matTooltipPosition="above">{{"common.features.RadiusBasecurve" | translate}}<span class="span-label-required"></span>
                    <input [ngClass]="{required:true, error: form.get('radiusBasecurve').errors && (form.get('radiusBasecurve').touched || (form.get('radiusBasecurve').dirty))}" (blur)="setValueWithFormat('RadiusBasecurve', 'radiusBasecurve')"
                    formControlName="radiusBasecurve" class="form-control parameter-input"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(3, 15)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex new-parameter">
                <label [matTooltip]="'common.hints.RadiusBaseCurve2' | translate" matTooltipPosition="above">{{"common.features.RadiusBaseCurve2" | translate}}<span class="span-label-required"></span>
                    <input [ngClass]="{required:true, error: form.get('radiusBasecurve2').errors && (form.get('radiusBasecurve2').touched || (form.get('radiusBasecurve2').dirty))}" (blur)="setValueWithFormat('RadiusBaseCurve2', 'radiusBasecurve2')"
                    formControlName="radiusBasecurve2" class="form-control parameter-input"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(3, 15)" matTooltipPosition="above">
                </div>
            </div>
        </div>

    </form>

    <app-validation-error [form]="form"></app-validation-error>
</div>